import { ICON_TYPE, SHOW_TASK_BY_ORDER } from '../../global/constants';
import { SHOW_TASK_GROUPING_TYPE } from '../../global/constants';
import { TASK_LIST_TYPE } from '../../global/constants';
import { SHOW_COMPLETED_TASK_BY_DATE } from '../../global/constants';
import { getWorkspaceViewPreferenceData } from '../../helpers/firebaseHelper';
import { NewTaskFilterInterface } from '../../interfaces/TaskInterface';
import { defaultDisplayFilters } from '../common';
import { DEFAULT_VIEW_FILTERS, RawView, ViewFilters, Icon } from '../interfaces/view';
import { rootStore } from '../rootStore';
import { makeAutoObservable } from 'mobx';

export class ViewModel {
  // Common
  id: string;
  name: string;
  description: string;
  icon: Icon = {
    type: ICON_TYPE.ICON,
    image: ''
  };
  color: number = 1;
  userIds: string[] = [];
  filters: ViewFilters;

  //Default fields
  createdById: string;
  createdOn: Date;
  updatedById: string;
  updatedOn: Date;

  //Display filters
  displayFilters: NewTaskFilterInterface = defaultDisplayFilters;

  constructor(rawView: RawView) {
    makeAutoObservable(this);

    // Common
    this.id = rawView.id;
    this.name = rawView.name;
    this.description = rawView.description;
    this.icon = rawView.icon;
    this.color = rawView.color;
    this.filters = rawView.filters;
    this.userIds = rawView.userIds;

    //Default fields
    this.createdById = rawView.createdById;
    this.createdOn = rawView.createdOn;
    this.updatedById = rawView.updatedById;
    this.updatedOn = rawView.updatedOn;

    //Display filters
    this.displayFilters = {
      showSubTask: false,
      showCompletedTaskByFilter: SHOW_COMPLETED_TASK_BY_DATE.LAST_MONTH,
      showRecentlyCompletedTask: true,
      showEmptyGroup: true,
      taskViewType: TASK_LIST_TYPE.TASKS,
      groupingStatus: SHOW_TASK_GROUPING_TYPE.GROUPING_BY_STATUS,
      orderByStatus: SHOW_TASK_BY_ORDER.CUSTOM
    };
  }

  get users() {
    return rootStore.workspaceStore.currentWorkspace?.users.filter((user) => this.userIds.includes(user.id)) || [];
  }

  clearAllFilters() {
    this.filters = DEFAULT_VIEW_FILTERS;
  }

  setDisplayFilters(displayFilters: any) {
    this.displayFilters = displayFilters;
  }

  updateTaskFilterType<K extends keyof NewTaskFilterInterface>(propsName: K, value: NewTaskFilterInterface[K]) {
    this.displayFilters[propsName] = value;
  }

  *updateViewPreferenceFromFirebase() {
    rootStore.viewStore.setLoading(true);
    try {
      const viewPreference: Partial<NewTaskFilterInterface> = yield getWorkspaceViewPreferenceData(this.id);
      const displayFilters = {
        ...this.displayFilters,
        ...viewPreference
      };
      this.setDisplayFilters(displayFilters);
    } finally {
      rootStore.viewStore.setLoading(false);
    }
  }
}

export const createObservableView = (rawView: RawView) => {
  return new ViewModel(rawView);
};
